import type { SVGProps } from 'react';
import { forwardRef, Ref } from 'react';

const SvgMeelopenStappen = (
  props: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>,
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 40 40"
    role="img"
    aria-hidden={true}
    ref={ref}
    {...props}
  >
    <path
      fill="#FF7842"
      fillRule="evenodd"
      d="M21.93 25.58c-.3-2.035-.184-4.11.34-6.1 1.22-5 4.28-8.48 6.83-7.85s3.62 5.16 2.39 10.12A15.3 15.3 0 0 1 29 27.31zM21.38 28a8 8 0 0 0-.58 1.61c-.74 3 .3 5.82 2.31 6.31s4.25-1.52 5-4.51a8.6 8.6 0 0 0 .24-1.7z"
      clipRule="evenodd"
    />
    <path
      fill="#FFBFA5"
      fillRule="evenodd"
      d="M10.88 19.75a15.1 15.1 0 0 1-2.44-5.61c-1.14-5 0-9.5 2.58-10.08s5.55 3 6.68 8c.488 2 .566 4.079.23 6.11zm.59 2.4c.008.573.078 1.143.21 1.7.68 3 2.88 5.07 4.9 4.6s3.11-3.27 2.43-6.27a8 8 0 0 0-.55-1.62z"
      clipRule="evenodd"
    />
    <path
      fill="#00215B"
      fillRule="evenodd"
      d="M15.103 7.947c-.994-1.185-2.01-1.646-2.832-1.46l-.222-.975c1.377-.313 2.742.506 3.82 1.793 1.097 1.308 2.009 3.216 2.508 5.41.436 1.78.503 3.631.196 5.439l-.055.32-3.975 1.01-.246-.969 3.34-.848a12.4 12.4 0 0 0-.233-4.718l-.002-.008c-.47-2.074-1.324-3.83-2.299-4.994M21.105 27.48l4.532 1.094-.234.972-3.738-.903a8 8 0 0 0-.38 1.147v.002a7.2 7.2 0 0 0-.206 2.18l-.998.057a8.2 8.2 0 0 1 .234-2.48c.145-.588.351-1.16.614-1.706z"
      clipRule="evenodd"
    />
  </svg>
);

/* eslint-disable import/no-default-export */
const ForwardRef = forwardRef(SvgMeelopenStappen);

export default ForwardRef;
